import { plural } from '@cian/utils';

export const getExperienceText = (minExperience?: number) =>
  minExperience ? `от ${minExperience} ${plural(minExperience, ['года', 'лет', 'лет'])}` : 'Можно без опыта';
